/**
 * The product name a station shows beside a garment's own size and colour.
 *
 * Shopify variant titles arrive with the variant baked onto the end
 * ("Heavyweight Tee - Black / L"). Every station card already shows size and
 * colour as their own badges, at their own scale, so leaving the suffix on the
 * name prints the same two facts twice and pushes the part that identifies the
 * product off the end of the line.
 *
 * Pure and station-agnostic on purpose: Catching, Print and Pressing each grew
 * their own copy of this, and two copies of a display rule drift into two
 * different names for one garment on one screen (the card caption and the
 * lightbox caption, for instance).
 */
export function cleanGarmentDisplayName(
  name: string,
  color: string | null,
  size: string | null,
): string {
  if (!color && !size) return name;

  // Longest first: " - Black / L" must be tried before " - Black", or the
  // size would be left stranded on the end.
  const suffixes: string[] = [];
  if (color && size) {
    suffixes.push(` - ${color} / ${size}`);
    suffixes.push(` - ${color}/${size}`);
  }
  if (color) suffixes.push(` - ${color}`);
  if (size) suffixes.push(` - ${size}`);

  for (const suffix of suffixes) {
    if (name.endsWith(suffix)) return name.slice(0, -suffix.length);
  }
  return name;
}
